import { MDXLayout } from "@/shared/components/MDX/MDXLayout";
import Content from "../help/production-lines.mdx";

export function ProductionLinesHelpPage() {
  return (
    <MDXLayout>
      <Content />
    </MDXLayout>
  );
}
